const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjQxNDIxIDEwSDExQzE4Ljg2ODkgMTAgMjIgMTMuMjU2MyAyMiAyMUgyMEMyMCAxNC4zNDM3IDE3Ljc0NjQgMTIgMTEgMTJINS40MTQyMUw5LjcwNzExIDE2LjI5MjlMOC4yOTI4OSAxNy43MDcxTDEuNTg1NzkgMTFMOC4yOTI4OSA0LjI5MjkxTDkuNzA3MTEgNS43MDcxMkw1LjQxNDIxIDEwWiIvPgo8L3N2Zz4K";
export {
  M as default
};
//# sourceMappingURL=back_arrow-5ccd81f7.mjs.map
